import { Link } from "react-router-dom";

export const Logo = ({ light = false }) => (
  <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5 group">
    <img
      src="/bfg-logo.png"
      alt="BFG — Breeze Financial Group"
      className="h-9 w-auto object-contain"
    />
    <span className="flex flex-col leading-none">
      <span
        className={`font-heading font-black text-lg tracking-tight ${
          light ? "text-[#F9F6F0]" : "text-[#0B132B]"
        }`}
      >
        BREEZE
      </span>
      <span className="text-[10px] tracking-[0.28em] uppercase text-[#29ABE2] font-semibold">
        Financial Group
      </span>
    </span>
  </Link>
);
